import {MarkdownEditor} from '@github-ui/markdown-editor'

export const CommentEditorButton = MarkdownEditor.ActionButton
